import { FormattedMessage } from 'react-intl';
import React from 'react';
import { DELIVERY_EXCEPTION_VIEW_ID, SHIPPED_VIEW_ID } from './view-id-constants';

export const DeliveryException = {
  label: <FormattedMessage defaultMessage='Delivery Exceptions' description='ordersPage.nav.deliveryExceptions' id='ppO3a4' />,
  id: DELIVERY_EXCEPTION_VIEW_ID,

  expandedDescription: (
    <FormattedMessage defaultMessage='Shipped / Delivery Exceptions' description='ordersPage.nav.deliveryExceptionsExpanded' id='P1I2kn' />
  ),

  parentId: SHIPPED_VIEW_ID,
};
